enum PrescriptionProductTypeVarilux {
    NONE = 'none',
    STANDARD_PROGRESSIVE_LENS = 'standard_progressive_lens',
    VARILUX_COMFORT = 'varilux_comfort',
    VARILUX_X_SERIES = 'varilux_x_series',
    VARILUX_PHYSIO_30 = 'varilux_physio_30'

}

export default PrescriptionProductTypeVarilux;